"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bob = exports.bsquared = exports.bsc = exports.polygon = void 0;
exports.polygon = {
    mainnet: {
        teleBTCAddress: "0x3BF668Fe1ec79a84cA8481CEAD5dbb30d61cC685",
    },
    testnet: {
        teleBTCAddress: "0x035c915d3c2d090dab645354c3d9a957ed5fc349",
    },
};
exports.bsc = {
    mainnet: {
        teleBTCAddress: "0xC58C1117DA964aEbe91fEF88f6f5703e79bdA574",
    },
    testnet: {
        teleBTCAddress: "0x2dC0a21691a3A0B8ED353Bf43f964966e2a65Cfd",
    },
};
exports.bsquared = {
    mainnet: {
        teleBTCAddress: "0x05698eaD40cD0941e6E5B04cDbd56CB470Db762A",
    },
    testnet: {
        teleBTCAddress: "",
    },
};
exports.bob = {
    mainnet: {
        teleBTCAddress: "0x0670bEeDC28E9bF0748cB254ABd946c87f033D9d",
    },
    testnet: {
        teleBTCAddress: "",
    },
};
//# sourceMappingURL=tokens-address.js.map